import React from 'react';
import './CompActive.css';

const CompActive = ({ 
  size = 'md', 
  color = 'primary', 
  text = 'Carregando...',
  className = '' 
}) => {
 

 

  return (
 
      <div className={`loader `}>
        Loading...
      </div>
    
  );
};

// Card skeleton para grids
export const CardSkeleton = ({ className = '' }) => (
  <div className={`loader`}>
        Loading...
      </div>
);

export default CompActive;